import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Project } from '../models/project';
import { Observable } from 'rxjs/Observable';

@Injectable()
export class ObjectImportService {

  constructor(private http: HttpClient) {
  }

  setMappings(project: Project, filename: string, data: any): Observable<any> {
    return this.http.post(`${project.url}/object-import/mappings`, { filename: filename, config: data })
  }

  configure(project: Project, filename: string, data: any): Observable<any> {
    return this.http.post(`${project.url}/object-import/configure`, { filename: filename, config: data })
  }

  import(project: Project, filename: string, objects: any[]) {
    return this.http.post(`${project.url}/object-import/import`, { filename: filename, rows: objects })
  }
}



// WEBPACK FOOTER //
// ./src/app/projects/object-import.service.ts